import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Form from 'react-bootstrap/Form';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Offcanvas from 'react-bootstrap/Offcanvas';
import image1 from '../../assets/img/netnexa logo.png'
function Reactnavbar() {
  return (
    <>
      {[ 'sm' ].map((expand) => (
        <Navbar id='transnav' key={expand} expand={expand} className=" margint mb-3">
          <Container fluid>
            <Navbar.Brand href="/"><a><img width={"40px"} src={image1} /><h1 id='robotologo' >Netnexa</h1></a></Navbar.Brand>
            <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-${expand}`} />
            <Navbar.Offcanvas
              id={`offcanvasNavbar-expand-${expand}`}
              aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
              placement="end"
            >
              <Offcanvas.Header closeButton>
                <Offcanvas.Title id={`offcanvasNavbarLabel-expand-${expand}`}>
                <a href='/'>
              <img  width={"70px"} src={image1} alt="" />
           <h1></h1>
            </a>
                </Offcanvas.Title>
              </Offcanvas.Header>
              <Offcanvas.Body>
                <Nav className="justify-content-end flex-grow-1 pe-3">
                  <Nav.Link id ='roboto' href="/About">About</Nav.Link>
                  <Nav.Link id ='roboto' href="/">Contact</Nav.Link>
                  <NavDropdown 
                    title="Our Services"
                    id={`offcanvasNavbarDropdown-expand-${expand}`}
                  >
                    <NavDropdown.Item id='roboto' href="/Homedubu">Dubu</NavDropdown.Item>
                    <NavDropdown.Item id='roboto' href="#action3">Uni-jobs</NavDropdown.Item>
                    <NavDropdown.Item id='roboto' href="#action4">
                     Mentor
                    </NavDropdown.Item>
                    <NavDropdown.Divider />
                    <NavDropdown.Item id='roboto' href="#action5">
                      Communities
                    </NavDropdown.Item>
                  </NavDropdown>
                </Nav>
                <span className="d-flex">
                  
                  <Button className='get-started-btn' variant="outline-success">Join</Button>
                </span>
              </Offcanvas.Body>
            </Navbar.Offcanvas>
          </Container>
        </Navbar>
      ))}
    </>
  );
}

export default Reactnavbar;